













import Vue from 'vue';

export default Vue.extend({
	name: 'AcceptedCreditCards',

	data() {
		return {
			cardTypes: [
				'VI',
				'AX',
				'MC',
				'DI',
			],
		};
	},

	computed: {
		acceptedCards(): any[] {
			if (!Array.isArray(this.settings.disable_cc_types)) {
				return this.cardTypes;
			}

			return this.cardTypes.filter((card: string) => !this.settings.disable_cc_types.includes(card));
		},

		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},
	},

	methods: {
		paymentImage(card: string): string {
			return this.$store.getters.paymentImage(card);
		},
	},
});
